import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class ClinicTypeService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdClinicType(clinicTypeId): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'ClinicType/deleteClinicType', {'clinicTypeId': clinicTypeId}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    countClinicType(clinicType): Observable<number> {
        return this.httpClient.post<number>(Constant.BASE_URL + 'ClinicType/count', {'clinicType': clinicType}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    updateClinicType(clinicType): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'ClinicType/updateClinicType', [clinicType], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addClinicType(clinicType): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'ClinicType/addClinicType', [clinicType], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    findAllClinicType(clinicType, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'ClinicType/findAllClinicType',
            {'clinicType': clinicType, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}}, this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

}
